import { useQuery } from '@tanstack/react-query';
import { getTransactions } from '@/services/transactions/TransactionsService';
import { SortTransaction, Transaction } from '@/services/transactions/TransactionTypes';
import { UseQueryResult } from '@tanstack/react-query/build/modern';

interface TransactionsResponse {
  data: {
    totalCount: number;
    skip: number;
    take: number;
    transactions: Transaction[];
  };
}

interface useGetTransactionsParams {
  skip: number;
  take: number;
  sort: SortTransaction;
}

const useGetTransactions = ({
  skip,
  take,
  sort,
}: useGetTransactionsParams): UseQueryResult<TransactionsResponse, Error> => {
  return useQuery({
    queryKey: ['getTransactions', skip, take, sort],
    queryFn: () => getTransactions(skip, take, sort),
    staleTime: 1000,
  });
};

export default useGetTransactions;
